// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".workoutSystemField__value[data-v-6e44890d]{font-size:var(--link-text-sm);color:var(--link-ink-secondary)}.workoutSystemField__value--warn[data-v-6e44890d]{color:#c45656;font-weight:var(--link-font-semibold)}.workoutSystemField__hint[data-v-6e44890d]{margin:6px 0 0;font-size:11px;line-height:1.45;color:var(--link-text-muted,#6b6560)}", ""]);
// Exports
module.exports = exports;
